const OUT_NORMAL_USER = 98;
const OUT_ADMIN_USER = 99;
export default {
  outNormalUser: OUT_NORMAL_USER,
  outAdminUser: OUT_ADMIN_USER,
};
